module.exports = __webpack_public_path__ + "static/media/menu.4b7aca9b.svg";